import React from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);

const PrintPrescription = React.forwardRef((prescription, ref) => {
  if (!prescription?.prescription) return null;

  const pdfSetting =
    prescription?.prescription?.organization?.organization_features?.find(
      (f) =>
        f?.key === "pdf_settings" &&
        f?.active === true &&
        f?.category === "Prescription",
    );
  const headerContent = pdfSetting?.data?.header_content || null;
  const footerContent = pdfSetting?.data?.footer_content || null;
  const headerHeight = Number(pdfSetting?.data?.header_height) || 0;
  const footerHeight = Number(pdfSetting?.data?.footer_height) || 0;
  const review_duration = Number(pdfSetting?.data?.review_duration) || 0;

  const investigationEnabled =
    prescription?.prescription?.organization?.organization_features?.some(
      (feature) =>
        feature?.key === "print_investigations_on_prescription" &&
        feature?.active === true,
    );

  const printSaltOnPrescription =
    prescription?.prescription?.organization?.organization_features?.some(
      (feature) =>
        feature?.key === "print_salts_on_prescription" &&
        feature?.active === true,
    );

  const formatDate = (dateString) => {
    if (!dateString) return "";
    return dayjs(dateString).tz("Asia/Kolkata").format("DD/MM/YYYY");
  };

  const visitDate = prescription?.prescription?.appointment?.visit_date
    ? formatDate(prescription?.prescription?.appointment?.visit_date)
    : "";

  const content = (
    <div
      style={{ paddingLeft: "70px", paddingRight: "80px", paddingTop: "5px" }}
    >
      <div style={{ maxWidth: "1300px", margin: "auto" }}>
     
       
        <div className="patient-details">
          <div
            style={{
              marginBottom: "10px",
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <p style={{ fontSize: "22px", fontWeight: "bolder" }}>
              <span style={{ fontWeight: "bolder" }}>
                {prescription?.prescription?.patient_full_name}
              </span>{" "}
              ({prescription?.prescription?.patient_uid})
            </p>
            <p style={{ fontSize: "18px", fontWeight: "bolder" }}>
              Date: {visitDate}
            </p>
          </div>

          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "18px",
            }}
            className="flex justify-between mb-3"
          >
            <span className="">
              {/*                
                Weight : &nbsp; */}
              <span className="">
                Weight: {prescription?.prescription?.appointment?.weight}{" "}
              </span>
              &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;
              <span>
                Age: {prescription?.prescription?.patient_age}{" "}
                &nbsp;&nbsp;&nbsp;&nbsp;{" "}
                {/* {prescription?.prescription?.patient_age}{" "} */}
              </span>
            </span>

            <span className="">
              Mobile: {prescription?.prescription?.patient_mobile}{" "}
              &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;
              <span style={{ textTransform: "capitalize" }}>
                {" "}
                {prescription?.prescription?.patient_gender}{" "}
              </span>
              {/* {prescription?.prescription?.patient_gender}{" "} */}
            </span>

            {prescription?.prescription?.appointment?.bp_d && (
              <span className="">
                BP : &nbsp;
                {prescription?.prescription?.appointment?.bp_s} /{" "}
                {prescription?.prescription?.appointment?.bp_d}
              </span>
            )}

            {prescription?.prescription?.appointment?.visit_type === "New" ||
            prescription?.prescription?.appointment?.visit_type === "Old"
              ? `(Valid for 1 Revisit within ${review_duration || "5"} days)`
              : prescription?.prescription?.appointment?.visit_type}
          </div>

          {prescription?.prescription?.diagnosis_list && (
            <table
              style={{
                width: "100%",
                // marginTop: "8px",
                marginBottom: "-12px",
              }}
            >
              <tr>
                <td style={{ width: "150px", verticalAlign: "top" }}>
                  <div>
                    <p>Diagnosis:</p>
                  </div>
                </td>
                <td>
                  {/* {prescription?.prescription?.diagnosis?.map((daig, index) => (
                    <div key={index}>
                      <p style={{ wordWrap: "break-word" }}>{daig.value} </p>
                    </div>
                  ))} */}

                  <p style={{ wordWrap: "break-word" }}>
                    {prescription?.prescription?.diagnosis_list
                      ?.split(",")
                      .join(", ")}{" "}
                  </p>
                </td>
              </tr>
            </table>
          )}

          {investigationEnabled &&
            prescription?.prescription?.appointment?.investigations?.length >
              0 && (
              <table
                style={{
                  width: "100%",
                  // marginTop: "-8px",
                  marginBottom: "-6px",
                }}
              >
                <tr>
                  <td
                    style={{
                      verticalAlign: "top",
                      width: "150px",
                      // padding: "4px",
                      margin: "0",
                    }}
                  >
                    <div>
                      <p>Investigations:</p>
                    </div>
                  </td>
                  <td
                    style={{
                      wordWrap: "break-word",
                    }}
                  >
                    <div>
                      <p style={{ margin: 0 }}>
                        {prescription?.prescription?.appointment?.investigations
                          .map(
                            (item) =>
                              `${item.name} ${item.value ? `(${item.value})` : ""}`,
                          )
                          .join(", ")}
                      </p>
                    </div>
                  </td>
                </tr>
              </table>
            )}

          <table
            style={{
              width: "100%",
              // marginTop: "0px",
              marginBottom: "-6px",
            }}
          >
            <tr>
              <td style={{ width: "150px", verticalAlign: "top" }}></td>
              <td>
                {" "}
                {prescription.prescription?.daily_exercise
                  ? "Regular Exercise ,"
                  : " "}{" "}
                {prescription.prescription?.physiotherapist
                  ? "Meet Physiotherapist ,"
                  : " "}{" "}
                {prescription.prescription?.psychologist
                  ? "Meet Psychologist ,"
                  : " "}{" "}
                {prescription.prescription?.dietitian ? "Dietitian, " : " "}{" "}
                {prescription.prescription?.ayurveda ? "Ayurveda, " : " "}{" "}
                {prescription.prescription?.yoga ? "Yoga, " : " "}{" "}
              </td>
            </tr>
          </table>

          {prescription?.prescription?.notes && (
            <table
              style={{
                width: "100%",
                // marginTop: "-7px",
                marginBottom: "-6px",
              }}
            >
              <tr>
                <td style={{ width: "150px", verticalAlign: "top" }}>
                  <div>
                    <p>Notes:</p>
                  </div>
                </td>
                <td>
                  <p style={{ wordWrap: "break-word" }}>
                    {prescription?.prescription?.notes}{" "}
                  </p>
                </td>
              </tr>
            </table>
          )}

          {/* {prescription?.prescription?.notes &&     <div style={{ marginTop: "9px" }}>
              <span style={{ marginRight: "24px" }}>Notes: </span>{" "}
              {prescription?.prescription?.notes}{" "}
            </div>
            } */}

          <div style={{ marginBottom: "30px", marginTop: "10px" }}>
            <h5 style={{ marginBottom: "17px", fontSize: "20px" }}>
              <b>Medicines</b>
            </h5>

            {prescription?.prescription?.medicines?.map((medi, index) => (
              <div
                key={index}
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  margin: "0",
                  padding: "0",
                  marginTop: "4px",
                  marginBottom: medi?.medicine_salt?.name ? "3px" : "",
                }}
              >
                <div
                  style={{
                    width: "2.2%",
                    fontSize: "16px",
                    marginTop: "2px",
                  }}
                >
                  {index + 1}
                </div>

                <div
                  style={{
                    margin: "0",
                    padding: "0",
                    width: "39.8%",
                    marginTop: "2px",
                  }}
                >
                  <p
                    style={{
                      fontSize: "16px",
                      margin: "0",
                      padding: "0",
                      fontWeight: "600",
                    }}
                  >
                    {medi?.form_type || ""} {medi?.name}
                  </p>
                  {printSaltOnPrescription && medi?.medicine_salt?.name && (
                    <small
                      style={{
                        display: "block",
                        width: "950px",
                        fontSize: "12px",
                        margin: "0",
                        padding: "0",
                        fontWeight: "400",
                        color: "#3A3A3A",
                      }}
                    >
                      {medi?.medicine_salt?.name}
                    </small>
                  )}
                </div>

                <div
                  style={{
                    width: "29%",
                    margin: "0",
                    padding: "0",
                    marginTop: "2px",
                  }}
                >
                  <p style={{ fontSize: "16px", margin: "0", padding: "0" }}>
                    {medi?.description.replace(/,/g, ", ")}
                  </p>
                </div>

                <div
                  style={{
                    width: "29%",
                    margin: "0",
                    padding: "0",
                    marginTop: "2px",
                  }}
                >
                  <p style={{ fontSize: "16px", margin: "0", padding: "0" }}>
                    {medi?.remark}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* <table style={{ marginBottom: "0px" }}>
              <tr>
                <td style={{ width: "150px" ,padding: "0" , margin:'0' }}>
                  <div>
                  {prescription?.prescription?.special_instructions
                  && 
                    <p> Spl instructions:</p>
                  }
                  </div>
                </td>
                <td>
                  <div>
                    <p>{prescription?.prescription?.special_instructions}</p>
                  </div>
                </td>
              </tr>

              <tr >
                <td style={{ width: "150px" , padding: "0", margin:'0'    }}>
                  <div >
                    {prescription?.prescription?.followup && 
                    <p>Follow up:</p>
}
                  </div>
                </td>
                <td>
                  <div>
                    <p>{prescription?.prescription?.followup}</p>
                  </div>
                </td>
              </tr>

              {/* <tr>
                <td style={{ width: "150px" }}>
                  <div>
                    <p>Videos:</p>
                  </div>
                </td>
                <td>
                  <div>
                    <p>
                      {" "}
                      <a href={prescription?.prescription?.vedios}> </a>{" "}
                    </p>
                  </div>
                </td>
              </tr> 

             

              <tr>
                <td style={{ width: "150px", verticalAlign: "top",  padding: "0" , margin:'0' } }>
                  <div>
                  {prescription?.prescription?.additional_tests &&   <p>Additional Tests:</p>}
                  </div>
                </td>
                <td style={{ wordWrap: "break-word" }}>
                  <div>
                    <p>
                      {prescription?.prescription?.additional_tests}
                    </p>
                  </div>
                </td>
              </tr>

              <tr>
                <td style={{verticalAlign: "top" , padding: "0", margin:'0'  }}>
                  <div>
                  {prescription?.prescription?.appointment?.investigations?.length>0  && <p>Investigations:</p> }
                  </div>
                </td>
                <td style={{ wordWrap: "break-word" }}>
                  <div>
                    <p>
                      {prescription?.prescription?.appointment?.investigations
                        .map((item) => item.toUpperCase())
                        .join(", ")}
                    </p>
                  </div>
                </td>
              </tr>

            </table> */}

          <table style={{ marginBottom: "0px", borderCollapse: "collapse" }}>
            {prescription?.prescription?.special_instructions && (
              <tr style={{ margin: "5px", padding: "5px" }}>
                <td
                  style={{
                    width: "150px",
                    padding: "4px",
                    margin: "0",
                    verticalAlign: "top",
                  }}
                >
                  <div>
                    <p style={{ margin: 0 }}>Spl instructions:</p>
                  </div>
                </td>
                <td style={{ padding: "4px", margin: "0" }}>
                  <div>
                    <p style={{ margin: 0 }}>
                      {prescription?.prescription?.special_instructions}
                    </p>
                  </div>
                </td>
              </tr>
            )}

            {prescription?.prescription?.followup && (
              <tr style={{ margin: "8px", padding: "8px" }}>
                <td
                  style={{
                    width: "150px",
                    padding: "4px",
                    margin: "0",
                    verticalAlign: "top",
                  }}
                >
                  <div>
                    <p style={{ margin: 0 }}>Follow up:</p>
                  </div>
                </td>
                <td style={{ padding: "4px", margin: "0" }}>
                  <div>
                    <p style={{ margin: 0 }}>
                      {prescription?.prescription?.followup}
                    </p>
                  </div>
                </td>
              </tr>
            )}

            <tr style={{ margin: "8px", padding: "8px" }}>
              <td
                style={{
                  width: "150px",
                  verticalAlign: "top",
                  padding: "4px",
                  margin: "0",
                }}
              >
                <div>
                  {prescription?.prescription?.additional_tests && (
                    <p style={{ margin: 0 }}>Additional Tests:</p>
                  )}
                </div>
              </td>
              <td
                style={{
                  wordWrap: "break-word",
                  padding: "4px",
                  margin: "0",
                }}
              >
                <div>
                  <p style={{ margin: 0 }}>
                    {prescription?.prescription?.additional_tests}
                  </p>
                </div>
              </td>
            </tr>

            {prescription?.prescription?.medical_tests_list && (
              <tr style={{ margin: "8px", padding: "8px" }}>
                <td
                  style={{
                    verticalAlign: "top",
                    padding: "4px",
                    margin: "0",
                  }}
                >
                  <div>
                    <p style={{ margin: 0 }}>Medical Tests:</p>
                  </div>
                </td>
                <td
                  style={{
                    wordWrap: "break-word",
                    padding: "4px",
                    margin: "0",
                  }}
                >
                  <div>
                    <p style={{ margin: 0 }}>
                      {prescription?.prescription?.medical_tests_list}
                    </p>
                  </div>
                </td>
              </tr>
            )}
          </table>
        </div>
      </div>
    </div>
  );
  const contentOld = (
    <div
      ref={ref}
      style={{
        //  minHeight:'1in'
        marginTop: headerHeight > 0 ? `${headerHeight}in` : "3.2in",
        marginBottom: footerHeight > 0 ? `${footerHeight}in` : "1.2in",
        paddingLeft: "70px",
        paddingRight: "80px",
        paddingTop: "5px",
        // maxWidth: "1000px",
        width: "1000px",
        color: "#3A3A3A",
        display: "flex",
        flexDirection: "column",
        fontFamily: "Lato, sans-serif",
        justifyContent: "space-between",
      }}
    >
      <div>
        <div style={{ position: "relative", left: "0", top: "10px" }}>
          {/* { prescription?.prescription?.organization?.logo && <img
            src={prescription?.prescription?.organization?.logo}
            alt=""
            width="95"
            height=""
            className="logo-img"
          />} */}
        </div>

        {/* <h1
          style={{
            textAlign: "center",
            marginTop: "5px",
            marginBottom: "10px",
            fontSize: "32px", 
          }}
        >
          {" "}
          {prescription?.prescription?.organization?.name}{" "}
        </h1> */}
        <br />

        <div style={{ maxWidth: "1300px", margin: "auto" }}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            {/* <div>
              <h1 style={{ fontSize: "24px", marginBottom: "10px" }}>
                {prescription?.prescription?.appointment?.doctor?.full_name}
              </h1>

             
            { doctor1Details?.map((item,index)=>
                <p key={index} style={{marginTop :'2px', marginBottom:'0px' , paddingTop:"2px" , paddingBottom :'0px'}}>{item}</p>
            )}

            </div> */}

            {/* <div style={{ marginRight: "10px" }}>
              <h1 style={{ fontSize: "24px", marginBottom: "10px" }}>
                {
                  prescription?.prescription?.appointment?.consultant_doctor
                    ?.full_name
                }
              </h1>
              { doctor2Details?.map((item,index)=>
               <p key={index} style={{marginTop :'2px', marginBottom:'0px' , paddingTop:"2px" , paddingBottom :'0px'}}>{item}</p>
            )}
               
            </div> */}
          </div>
          <br />
          {/* <hr /> */}
          <br />

          <div className="patient-details">
            <div
              style={{
                marginBottom: "10px",
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <p style={{ fontSize: "22px", fontWeight: "bolder" }}>
                <span style={{ fontWeight: "bolder" }}>
                  {prescription?.prescription?.patient_full_name}
                </span>{" "}
                ({prescription?.prescription?.patient_uid})
              </p>
              <p style={{ fontSize: "18px", fontWeight: "bolder" }}>
                Date: {visitDate}
              </p>
            </div>

            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "18px",
              }}
              className="flex justify-between mb-3"
            >
              <span className="">
                {/*                
                Weight : &nbsp; */}
                <span className="">
                  Weight: {prescription?.prescription?.appointment?.weight}{" "}
                </span>
                &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;
                <span>
                  Age: {prescription?.prescription?.patient_age}{" "}
                  &nbsp;&nbsp;&nbsp;&nbsp;{" "}
                  {/* {prescription?.prescription?.patient_age}{" "} */}
                </span>
              </span>

              <span className="">
                Mobile: {prescription?.prescription?.patient_mobile}{" "}
                &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;
                <span style={{ textTransform: "capitalize" }}>
                  {" "}
                  {prescription?.prescription?.patient_gender}{" "}
                </span>
                {/* {prescription?.prescription?.patient_gender}{" "} */}
              </span>

              {prescription?.prescription?.appointment?.bp_d && (
                <span className="">
                  BP : &nbsp;
                  {prescription?.prescription?.appointment?.bp_s} /{" "}
                  {prescription?.prescription?.appointment?.bp_d}
                </span>
              )}

              {prescription?.prescription?.appointment?.visit_type === "New" ||
              prescription?.prescription?.appointment?.visit_type === "Old"
                ? `(Valid for 1 Revisit within ${review_duration || "5"} days)`
                : prescription?.prescription?.appointment?.visit_type}
            </div>

            {prescription?.prescription?.diagnosis_list && (
              <table
                style={{
                  width: "100%",
                  // marginTop: "8px",
                  marginBottom: "-12px",
                }}
              >
                <tr>
                  <td style={{ width: "150px", verticalAlign: "top" }}>
                    <div>
                      <p>Diagnosis:</p>
                    </div>
                  </td>
                  <td>
                    {/* {prescription?.prescription?.diagnosis?.map((daig, index) => (
                    <div key={index}>
                      <p style={{ wordWrap: "break-word" }}>{daig.value} </p>
                    </div>
                  ))} */}

                    <p style={{ wordWrap: "break-word" }}>
                      {prescription?.prescription?.diagnosis_list
                        ?.split(",")
                        .join(", ")}{" "}
                    </p>
                  </td>
                </tr>
              </table>
            )}

            {investigationEnabled &&
              prescription?.prescription?.appointment?.investigations?.length >
                0 && (
                <table
                  style={{
                    width: "100%",
                    // marginTop: "-8px",
                    marginBottom: "-6px",
                  }}
                >
                  <tr>
                    <td
                      style={{
                        verticalAlign: "top",
                        width: "150px",
                        // padding: "4px",
                        margin: "0",
                      }}
                    >
                      <div>
                        <p>Investigations:</p>
                      </div>
                    </td>
                    <td
                      style={{
                        wordWrap: "break-word",
                      }}
                    >
                      <div>
                        <p style={{ margin: 0 }}>
                          {prescription?.prescription?.appointment?.investigations
                            .map(
                              (item) =>
                                `${item.name} ${item.value ? `(${item.value})` : ""}`,
                            )
                            .join(", ")}
                        </p>
                      </div>
                    </td>
                  </tr>
                </table>
              )}

            <table
              style={{
                width: "100%",
                // marginTop: "0px",
                marginBottom: "-6px",
              }}
            >
              <tr>
                <td style={{ width: "150px", verticalAlign: "top" }}></td>
                <td>
                  {" "}
                  {prescription.prescription?.daily_exercise
                    ? "Regular Exercise ,"
                    : " "}{" "}
                  {prescription.prescription?.physiotherapist
                    ? "Meet Physiotherapist ,"
                    : " "}{" "}
                  {prescription.prescription?.psychologist
                    ? "Meet Psychologist ,"
                    : " "}{" "}
                  {prescription.prescription?.dietitian ? "Dietitian, " : " "}{" "}
                  {prescription.prescription?.ayurveda ? "Ayurveda, " : " "}{" "}
                  {prescription.prescription?.yoga ? "Yoga, " : " "}{" "}
                </td>
              </tr>
            </table>

            {prescription?.prescription?.notes && (
              <table
                style={{
                  width: "100%",
                  // marginTop: "-7px",
                  marginBottom: "-6px",
                }}
              >
                <tr>
                  <td style={{ width: "150px", verticalAlign: "top" }}>
                    <div>
                      <p>Notes:</p>
                    </div>
                  </td>
                  <td>
                    <p style={{ wordWrap: "break-word" }}>
                      {prescription?.prescription?.notes}{" "}
                    </p>
                  </td>
                </tr>
              </table>
            )}

            {/* {prescription?.prescription?.notes &&     <div style={{ marginTop: "9px" }}>
              <span style={{ marginRight: "24px" }}>Notes: </span>{" "}
              {prescription?.prescription?.notes}{" "}
            </div>
            } */}

            <div style={{ marginBottom: "30px", marginTop: "10px" }}>
              <h5 style={{ marginBottom: "17px", fontSize: "20px" }}>
                <b>Medicines</b>
              </h5>

              {prescription?.prescription?.medicines?.map((medi, index) => (
                <div
                  key={index}
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    margin: "0",
                    padding: "0",
                    marginTop: "4px",
                    marginBottom: medi?.medicine_salt?.name ? "3px" : "",
                  }}
                >
                  <div
                    style={{
                      width: "2.2%",
                      fontSize: "16px",
                      marginTop: "2px",
                    }}
                  >
                    {index + 1}
                  </div>

                  <div
                    style={{
                      margin: "0",
                      padding: "0",
                      width: "39.8%",
                      marginTop: "2px",
                    }}
                  >
                    <p
                      style={{
                        fontSize: "16px",
                        margin: "0",
                        padding: "0",
                        fontWeight: "600",
                      }}
                    >
                      {medi?.form_type || ""} {medi?.name}
                    </p>
                    {printSaltOnPrescription && medi?.medicine_salt?.name && (
                      <small
                        style={{
                          display: "block",
                          width: "950px",
                          fontSize: "12px",
                          margin: "0",
                          padding: "0",
                          fontWeight: "400",
                          color: "#3A3A3A",
                        }}
                      >
                        {medi?.medicine_salt?.name}
                      </small>
                    )}
                  </div>

                  <div
                    style={{
                      width: "29%",
                      margin: "0",
                      padding: "0",
                      marginTop: "2px",
                    }}
                  >
                    <p style={{ fontSize: "16px", margin: "0", padding: "0" }}>
                      {medi?.description.replace(/,/g, ", ")}
                    </p>
                  </div>

                  <div
                    style={{
                      width: "29%",
                      margin: "0",
                      padding: "0",
                      marginTop: "2px",
                    }}
                  >
                    <p style={{ fontSize: "16px", margin: "0", padding: "0" }}>
                      {medi?.remark}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* <table style={{ marginBottom: "0px" }}>
              <tr>
                <td style={{ width: "150px" ,padding: "0" , margin:'0' }}>
                  <div>
                  {prescription?.prescription?.special_instructions
                  && 
                    <p> Spl instructions:</p>
                  }
                  </div>
                </td>
                <td>
                  <div>
                    <p>{prescription?.prescription?.special_instructions}</p>
                  </div>
                </td>
              </tr>

              <tr >
                <td style={{ width: "150px" , padding: "0", margin:'0'    }}>
                  <div >
                    {prescription?.prescription?.followup && 
                    <p>Follow up:</p>
}
                  </div>
                </td>
                <td>
                  <div>
                    <p>{prescription?.prescription?.followup}</p>
                  </div>
                </td>
              </tr>

              {/* <tr>
                <td style={{ width: "150px" }}>
                  <div>
                    <p>Videos:</p>
                  </div>
                </td>
                <td>
                  <div>
                    <p>
                      {" "}
                      <a href={prescription?.prescription?.vedios}> </a>{" "}
                    </p>
                  </div>
                </td>
              </tr> 

             

              <tr>
                <td style={{ width: "150px", verticalAlign: "top",  padding: "0" , margin:'0' } }>
                  <div>
                  {prescription?.prescription?.additional_tests &&   <p>Additional Tests:</p>}
                  </div>
                </td>
                <td style={{ wordWrap: "break-word" }}>
                  <div>
                    <p>
                      {prescription?.prescription?.additional_tests}
                    </p>
                  </div>
                </td>
              </tr>

              <tr>
                <td style={{verticalAlign: "top" , padding: "0", margin:'0'  }}>
                  <div>
                  {prescription?.prescription?.appointment?.investigations?.length>0  && <p>Investigations:</p> }
                  </div>
                </td>
                <td style={{ wordWrap: "break-word" }}>
                  <div>
                    <p>
                      {prescription?.prescription?.appointment?.investigations
                        .map((item) => item.toUpperCase())
                        .join(", ")}
                    </p>
                  </div>
                </td>
              </tr>

            </table> */}

            <table style={{ marginBottom: "0px", borderCollapse: "collapse" }}>
              {prescription?.prescription?.special_instructions && (
                <tr style={{ margin: "5px", padding: "5px" }}>
                  <td
                    style={{
                      width: "150px",
                      padding: "4px",
                      margin: "0",
                      verticalAlign: "top",
                    }}
                  >
                    <div>
                      <p style={{ margin: 0 }}>Spl instructions:</p>
                    </div>
                  </td>
                  <td style={{ padding: "4px", margin: "0" }}>
                    <div>
                      <p style={{ margin: 0 }}>
                        {prescription?.prescription?.special_instructions}
                      </p>
                    </div>
                  </td>
                </tr>
              )}

              {prescription?.prescription?.followup && (
                <tr style={{ margin: "8px", padding: "8px" }}>
                  <td
                    style={{
                      width: "150px",
                      padding: "4px",
                      margin: "0",
                      verticalAlign: "top",
                    }}
                  >
                    <div>
                      <p style={{ margin: 0 }}>Follow up:</p>
                    </div>
                  </td>
                  <td style={{ padding: "4px", margin: "0" }}>
                    <div>
                      <p style={{ margin: 0 }}>
                        {prescription?.prescription?.followup}
                      </p>
                    </div>
                  </td>
                </tr>
              )}

              <tr style={{ margin: "8px", padding: "8px" }}>
                <td
                  style={{
                    width: "150px",
                    verticalAlign: "top",
                    padding: "4px",
                    margin: "0",
                  }}
                >
                  <div>
                    {prescription?.prescription?.additional_tests && (
                      <p style={{ margin: 0 }}>Additional Tests:</p>
                    )}
                  </div>
                </td>
                <td
                  style={{
                    wordWrap: "break-word",
                    padding: "4px",
                    margin: "0",
                  }}
                >
                  <div>
                    <p style={{ margin: 0 }}>
                      {prescription?.prescription?.additional_tests}
                    </p>
                  </div>
                </td>
              </tr>

              {prescription?.prescription?.medical_tests_list && (
                <tr style={{ margin: "8px", padding: "8px" }}>
                  <td
                    style={{
                      verticalAlign: "top",
                      padding: "4px",
                      margin: "0",
                    }}
                  >
                    <div>
                      <p style={{ margin: 0 }}>Medical Tests:</p>
                    </div>
                  </td>
                  <td
                    style={{
                      wordWrap: "break-word",
                      padding: "4px",
                      margin: "0",
                    }}
                  >
                    <div>
                      <p style={{ margin: 0 }}>
                        {prescription?.prescription?.medical_tests_list}
                      </p>
                    </div>
                  </td>
                </tr>
              )}
            </table>
          </div>
        </div>
      </div>

      {/* <div className="footer" style={{marginBottom:"15px"  }}> */}
      {/* <hr /> */}
      {/* <p className="text-center pt-3  text-[12px]">
          {prescription?.prescription?.organization?.address}{" "}
          {prescription?.prescription?.organization?.city}
          { (prescription?.prescription?.organization?.state)}{" "}
          {prescription?.prescription?.organization?.contact_number}{" "}
          {prescription?.prescription?.organization?.email} |{" "}
          {prescription?.prescription?.organization?.website} &nbsp; Advice
          given without physical checkup is Provisional, pending physical
          evaluation by a qualified Doctor.{" "}
          <b>Patient Can Buy Generic Medicine of Same Salt</b>
        </p> */}
      {/* </div> */}
    </div>
  );
  if (pdfSetting && headerContent) {
    console.log("this is pdf setting content");
    // Height of the bottom band reserved for the footer on every page.
    const footerReserveIn = footerHeight > 0 ? footerHeight : 1.5;
    return (
      <div
        ref={ref}
        style={{
          width: "1000px",
          color: "#3A3A3A",
          fontFamily: "Lato, sans-serif",
        }}
      >
        {/*
          Header repeats at the top of every page via the table <thead>.

          Footer strategy (works reliably through react-to-print, unlike
          @page margins which Chrome ignores here):
            1. An EMPTY <tfoot> spacer reserves the bottom band on EVERY page
               via native table pagination, so <tbody> content can never flow
               into it — this is what prevents overlap.
            2. A position:fixed block paints the actual footer at the physical
               bottom of EVERY page (including a short last page), landing
               inside the band the spacer reserved.
        */}
        <table
          style={{
            width: "100%",
            tableLayout: "fixed",
            borderCollapse: "collapse",
          }}
        >
          {headerContent && (
            <thead>
              <tr>
                <td
                  style={
                    headerHeight > 0 ? { paddingTop: `${headerHeight}in` } : {}
                  }
                >
                  {headerHeight > 0 && (
                    <style>{`.pdf-header-inner > div { margin-top: 0 !important }`}</style>
                  )}
                  <div
                    className="pdf-header-inner"
                    dangerouslySetInnerHTML={{ __html: headerContent }}
                  />
                </td>
              </tr>
            
            </thead>
          )}

          {footerContent && (
            <tfoot>
              <tr>
                <td
                  style={{ height: `${footerReserveIn}in`, border: 0 }}
                  aria-hidden="true"
                />
              </tr>
            </tfoot>
          )}

          <tbody>
            <tr>
              <td style={{ verticalAlign: "top" }}>{content}</td>
            </tr>
          </tbody>
        </table>

        {footerContent && (
          <div
            className="pdf-footer-fixed"
            style={{ position: "fixed", bottom: 0, left: 0, width: "1000px" }}
          >
            <div
              className="pdf-footer-inner"
              dangerouslySetInnerHTML={{ __html: footerContent }}
            />
          </div>
        )}
      </div>
    );
  }

  return contentOld;
});

PrintPrescription.displayName = "PrintPrescription";
export default PrintPrescription;
